exports.ByName = {
  ValueAdded: { Id: 1 },
  NoValueAdded: { Id: 2 }
};
